import VForm from '@/CommonDP/lib/vform/VFormDesigner.umd.min.js';
import { getCustomWidget } from "@/CommonDP/VForm/utils";
import { cloneDeep } from 'lodash';
const { VFormSDK: { getDefaultFormConfig }} = VForm;
function defaultFormInit() {
  const defaultFormConfig = getDefaultFormConfig();
  return {
    ...defaultFormConfig,
    onFormSubmit: '',
    size: "small"
  };
}
// 全局表单配置项
export const formConfig = cloneDeep(defaultFormInit());
/**
 * 表单配置组件
 * 后台返回的字段意思
 * @param metaId --主键ID
 * @param displayDataLength --字段显示长度
 * @param columnDisplayName --字段显示名称
 * @param columnName --字段名称
 * @param displayDataType --控件类型
 * @param remark --备注
 * @param defaultValue --默认值
 * @param isInternalField --是否内部字段
 * @param isNullable --是否必填(0:必填 1:不必填)
 */
// 根据后台表单字段读取该模型数据是哪种表单
export function widgetListMap(data) {
  const { displayDataType: type } = data;
  return getCustomWidget(type, data) ;
}
